import { render } from "./OurProducts.vue?vue&type=template&id=a03c60d0&scoped=true"
import script from "./OurProducts.vue?vue&type=script&lang=js"
export * from "./OurProducts.vue?vue&type=script&lang=js"

import "./OurProducts.vue?vue&type=style&index=0&id=a03c60d0&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a03c60d0"]])

export default __exports__